'use client';

import { motion, useReducedMotion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import BlogPostCard, { postGridVariants } from '@/components/ui/BlogPostCard';
import { getRelatedPosts } from '@/lib/blog';

// "Read also" — two other articles at the end of a blog post. The pick is
// pseudo-random but seeded by the current post id (see getRelatedPosts), so
// SSR and client always agree.
export default function RelatedPosts({ currentId }: { currentId: string }) {
  const t = useTranslations('blog');
  const reduceMotion = useReducedMotion();
  const related = getRelatedPosts(currentId);

  if (related.length === 0) return null;

  return (
    <>
      <h2 className="font-headline text-headline-lg font-bold tracking-[0.02em] text-on-surface">
        {t('relatedHeading')}
      </h2>
      <motion.div
        className="mt-stack-lg grid grid-cols-1 gap-6 md:grid-cols-2"
        variants={postGridVariants}
        initial={reduceMotion ? false : 'hidden'}
        whileInView="visible"
        viewport={{ once: true, margin: '-10% 0px' }}
      >
        {related.map((meta) => (
          <BlogPostCard key={meta.id} meta={meta} />
        ))}
      </motion.div>
    </>
  );
}
